export const getPropertyName = (inputString: string): string | undefined => {
  const lastHashIndex: number = inputString.lastIndexOf('#');
  if (lastHashIndex > -1) {
    return inputString.substring(lastHashIndex + 1);
  } else {
    return undefined;
  }
};
